export const PERMISSIONS = {
  IS_ADMIN: 'is_admin',
  IS_EMPLOYEE: 'is_employee',
  IS_AFFILIATE: 'is_affiliate',

  NOTES: { ADD: 'notes.add_note', VIEW: 'notes.view_note' },

  DNI: {
    ADD: 'affiliate_documents.add_dni',
    VIEW: 'affiliate_documents.view_dni',
    EDIT: 'affiliate_documents.change_dni',
    VIEW_FILE: 'affiliate_documents.view_dniimage',
    VIEW_HISTORY: 'affiliate_documents.view_historicaldni',
  },

  CBU: {
    ADD: 'affiliate_documents.add_cbu',
    VIEW: 'affiliate_documents.view_cbu',
    EDIT: 'affiliate_documents.change_cbu',
    VIEW_FILE: 'affiliate_documents.view_cbufile',
    VIEW_HISTORY: 'affiliate_documents.view_historicalcbu',
  },

  IOMA_CREDENTIAL: {
    ADD: 'affiliate_documents.add_iomacredential',
    VIEW: 'affiliate_documents.view_iomacredential',
    EDIT: 'affiliate_documents.change_iomacredential',
    VIEW_FILE: 'affiliate_documents.view_iomacredentialimage',
    VIEW_HISTORY: 'affiliate_documents.view_historicaliomacredential',
  },

  STUDENT_CERTIFICATE: {
    ADD: 'affiliate_documents.add_regularstudentcertificate',
    VIEW: 'affiliate_documents.view_regularstudentcertificate',
    EDIT: 'affiliate_documents.change_regularstudentcertificate',
    VIEW_FILE: 'affiliate_documents.view_regularstudentcertificatefile',
    VIEW_HISTORY: 'affiliate_documents.view_historicalregularstudentcertificate',
  },

  PAYCHECK: {
    ADD: 'affiliate_documents.add_paycheck',
    VIEW: 'affiliate_documents.view_paycheck',
    EDIT: 'affiliate_documents.change_paycheck',
    VIEW_FILE: 'affiliate_documents.view_paycheckfile',
    VIEW_HISTORY: 'affiliate_documents.view_historicalpaycheck',
  },

  COVERAGE: {
    VIEW: 'files.view_filecoverage',
    ADD: 'files.add_filecoverage',
    EDIT: 'files.change_filecoverage',
    DELETE: 'files.delete_filecoverage',
  },

  DOCUMENT_SCOPE_COVERAGE: {
    VIEW: 'files.view_filescope',
    ADD: 'files.add_filescope',
    EDIT: 'files.change_filescope',
    DELETE: 'files.delete_filescope',

    VIEW_DETAIL: 'files.scope_view_detail',
    VALIDATE: 'files.scope_validate',
    CANCEL: 'files.scope_cancel',
    RECUSE: 'files.scope_resource',
    READJUSTMENT: 'files.scope_readjustment',
  },

  RESOURCE_COVERAGE: {
    VIEW: 'files.view_fileresource',
    ADD: 'files.add_fileresource',
    EDIT: 'files.change_fileresource',
    DELETE: 'files.delete_fileresource',

    VIEW_DETAIL: 'files.resource_view_detail',
    CANCEL: 'files.resource_deny',
    APPROVE: 'files.resource_approve',
  },

  AUTHORIZATION_COVERAGE: {
    VIEW: "files.view_fileauthorization",
    ADD: "files.add_fileauthorization",
    EDIT: "files.change_fileauthorization",
    DELETE: "files.delete_fileauthorization",
  },

  NOTIFICATION_COVERAGE: {
    VIEW: 'notification.view_affiliatenotification',
    ADD: 'notification.add_affiliatenotification',
    EDIT: 'notification.change_affiliatenotification',
    DELETE: 'notification.delete_affiliatenotification',
  },

  PARTIAL_PAYMENT_COVERAGE: {
    VIEW: 'files.view_filepartialpayment',
    ADD: 'files.add_filepartialpayment',
    EDIT: 'files.change_filepartialpayment',
    DELETE: 'files.delete_filepartialpayment',

    VIEW_DETAIL: 'files.partial_view_detail',
    VALIDATE: 'files.partial_validate',
    PENDING_VALIDATE: 'files.partial_pending_validate',
    PRESENT: 'files.partial_present',
    CANCEL: 'files.partial_cancel',
  },

  VALIDATION_FAMILY: {
    ADD: 'affiliate_documents.add_validationaffiliateimage',
    VIEW: 'affiliate_documents.view_validationaffiliateimage',
    EDIT: 'affiliate_documents.change_validationaffiliateimage',
    VIEW_FILE: 'affiliate_documents.view_validationaffiliateimage',
    VIEW_HISTORY: 'affiliate_documents.view_validationaffiliateimage',
  },

  ALLOWANCES: {
    ADD: 'allowances.add_allowance',
    VIEW: 'allowances.view_allowance',
    EDIT: 'allowances.change_allowance',
    DELETE: 'allowances.delete_allowance',
    ADD_LIMIT: 'allowances.add_allowancelimit',
    VIEW_LIMIT: 'allowances.view_allowancelimit',
  },

  AFFILIATES: {
    ADD: 'affiliates.add_affiliate',
    VIEW_FAMILIAR: 'affiliates.view_affiliaterelationship',
    ADD_FAMILIAR: 'affiliates.add_affiliaterelationship',
    EDIT: 'affiliates.change_affiliate',
    VIEW: 'affiliates.view_affiliate',
    DELETE: 'affiliates.delete_affiliate',
    CHANGE_TYPE: 'affiliates.change_affiliatetype',

    VIEW_HISTORY: 'affiliates.view_historicalaffiliate',
    VIEW_CHANGES: 'affiliates.view_affiliatestatechange',

    // state changes
    MAKE_VOLUNTARY: 'affiliates.make_voluntary',
    REAFFILIATE: 'affiliates.reaffiliate',
    DISAFFILIATE: 'affiliates.disaffiliate',
    MAKE_FAMILIAR: 'affiliates.make_familiar',
    MAKE_PRINCIPAL: 'affiliates.make_principal',

    STATISTICS: 'affiliates.affiliate_statistics',
  },

  PARTIAL_PAYMENT_REQUEST: {
    ADD: 'partialPaymentRequest.add_partialpaymentrequest',
    VIEW: 'partialPaymentRequest.view_partialpaymentrequest',
    EDIT: 'partialPaymentRequest.change_partialpaymentrequest',
    DELETE: 'partialPaymentRequest.delete_partialpaymentrequest',
    PRE_APPROVE: 'partialPaymentRequest.pre_approve',
    APPROVE: 'partialPaymentRequest.approve',
    REJECT: 'partialPaymentRequest.reject',
    TRANSFER: 'partialPaymentRequest.transfer',
  },

  USERS: {
    ADD: 'users.add_user',
    VIEW: 'users.view_user',
    EDIT: 'users.change_user',
    CHANGE_ACTIVE_USER: 'users.change_active_user',

    EMPLOYEE_STATISTICS: 'users.employee_statistics',
  },

  REPRESENTATIVES: {
    VIEW_FILE: 'representatives.view_representationfile',
    ADD: 'representatives.add_representationrelationship',
    VIEW: 'representatives.view_representationrelationship',
    EDIT: 'representatives.change_representationrelationship',
    DELETE: 'representatives.delete_representationrelationship',
    VIEW_HISTORY: 'representatives.view_historicalrepresentationrelationship',
  },

  FILES: {
    ADD: 'files.add_file',
    VIEW: 'files.view_file',
    EDIT: 'files.change_file',
    VIEW_HISTORY: 'files.view_historicalfile',
    VIEW_PAYEMENTS: 'files.view_filepayment',
    PRINT_COVER: 'files.print_cover',
    CREATE: 'files.create',
    PRESENT: 'files.present',
    PRE_APPROVE: 'files.pre_approve',
    APPROVE: 'files.approve',
    CANCEL: 'files.cancel',
    DISAPPROVE: 'files.disapprove',
    REFUSE: 'files.refuse',
    PAY: 'files.pay',
    STATISTICS: 'files.file_statistics',
  },

  FILE_VALIDATION: {
    ADD: 'files.add_filevalidation',
    VIEW: 'files.view_filevalidation',
    EDIT: 'files.change_filevalidation',
  },

  FILE_ATTACHMENT: {
    ADD: 'files.add_fileattachment',
    VIEW: 'files.view_fileattachment',
    EDIT: 'files.change_fileattachment',
    DELETE: 'files.delete_fileattachment',
  },

  ATTACHMENT_TRAMIT: {
    VIEW: 'tramits.view_attachmenttramit',
    ADD: 'tramits.add_attachmenttramit',
    EDIT: 'tramits.change_attachmenttramit',
    DELETE: 'tramits.delete_attachmenttramit'
  },


  REQUESTED_FILES: {
    ADD: 'files.add_requestedfile',
    VIEW: 'files.view_requestedfile',
    EDIT: 'files.change_requestedfile',
  },

  BOXES: {
    ADD: 'boxes.add_boxes',
    VIEW: 'boxes.view_boxes',
    EDIT: 'boxes.change_boxes',
    DELETE: 'boxes.delete_boxes',
    VIEW_HISTORY: 'boxes.view_boxeschange',
  },

  DETAILBOX: {
    ADD: 'boxes.add_detailbox',
    VIEW: 'boxes.view_detailbox',
    EDIT: 'boxes.change_detailbox',
    DELETE: 'boxes.delete_detailbox',
  },

  LOANS: {
    ADD: 'loans.add_loan',
    VIEW: 'loans.view_loan',
    EDIT: 'loans.change_loan',
    VIEW_HISTORY: 'loans.view_historicalloan',
  },

  LOANS_TYPES: {
    VIEW: 'loans.view_loantype',
  },

  LOANS_LIQUIDATION: {
    ADD: 'loans.add_loanliquidation',
    VIEW: 'loans.view_loanliquidation',
    EDIT: 'loans.change_loanliquidation',
    VIEW_HISTORY: 'loans.view_historicalloanliquidation',
  },

  LOANS_INSTALLMENTS: {
    ADD: 'loans.add_loaninstallment',
    VIEW: 'loans.view_loaninstallment',
    EDIT: 'loans.change_loaninstallment',

    HANDLE_SPB: 'loans.handle_spb_installments',
    HANDLE_IPS: 'loans.handle_ips_installments',
    HANDLE_CBU: 'loans.handle_cbu_installments',
    HANDLE_CASH: 'loans.handle_cash_installments',
  },

  ODONTOGRAMS: {
    ADD: 'files.add_odontogram',
    VIEW: 'files.view_odontogram',
    EDIT: 'files.change_odontogram',
  },

  RESOLUTIONS: {
    EDIT: 'files.change_fileresolution',
    ADD: 'files.add_fileresolution',
    VIEW: 'files.view_fileresolution',
  },

  PHARMACY_PRESCRIPTION: {
    VIEW: 'pharmacies.view_prescriptions',
    ADD: 'pharmacies.add_prescriptions',
    STATISTICS: 'pharmacies.precriptions_statistics',
  },

  PHARMACY_PRODUCTS: {
    VIEW: 'pharmacies.view_products',
    ADD: 'pharmacies.add_products',
    EDIT: 'pharmacies.change_products',
    STATISTICS: 'pharmacies.precriptions_products_statistics',
  },

  BIOCHEMEST_VOUCHER: {
    VIEW: 'biochemists.view_voucher',
    ADD: 'biochemists.add_voucher',
    EDIT: 'biochemists.change_voucher',
  },

  BIOCHEMEST_VOUCHER_DETAILS: {
    VIEW: 'biochemists.view_voucherdetails',
    ADD: 'biochemists.add_voucherdetails',
    EDIT: 'biochemists.edit_voucherdetails',
  },

  TICKETS: {
    VIEW: 'files.view_ticketfileattachment',
    ADD: 'files.add_ticketfileattachment',
    EDIT: 'files.change_ticketfileattachment',
    DELETE: 'files.delete_receiptfileattachment',
    VALIDATE: 'files.validate',
  },

  RECEIPTS: {
    VIEW: 'files.view_receiptfileattachment',
    ADD: 'files.add_receiptfileattachment',
    EDIT: 'files.change_receiptfileattachment',
    DELETE: 'files.delete_receiptfileattachment',
    VALIDATE: 'files.validate',
  },

  VOUCHERS: {
    VIEW: 'files.view_voucherfileattachment',
    ADD: 'files.add_voucherfileattachment',
    EDIT: 'files.change_voucherfileattachment',
    DELETE: 'files.delete_receiptfileattachment',
    VALIDATE: 'files.validate',
  },

  CBUPROCESSING: {
    EDIT: 'affiliate_documents.change_cbuprocessing',
    ADD: 'affiliate_documents.view_cbuprocessing',
    VIEW: 'affiliate_documents.view_cbuprocessing',
    VIEW_HISTORY: 'affiliate_documents.view_historicalcbuprocessing',
  },

  CADETESPROCESSING: {
    EDIT: 'affiliates.change_cadetesprocessing',
    ADD: 'affiliates.view_cadetesprocessing',
    VIEW: 'affiliates.view_cadetesprocessing',
    VIEW_HISTORY: 'affiliates.view_historicalcadetesprocessing',
  },

  AFFILIATEPROCESSING: {
    EDIT: 'affiliates.change_affiliateprocessing',
    ADD: 'affiliates.add_affiliateprocessing',
    VIEW: 'affiliates.view_affiliateprocessing',
    VIEW_HISTORY: 'affiliates.view_historicalaffiliateprocessing',
  },

  PRODUCTSPROCESSING: {
    VIEW: 'pharmacies.view_productsprocessing',
    ADD: 'pharmacies.add_productsprocessing',
    EDIT: 'pharmacies.change_productsprocessing',
    VIEW_HISTORY: 'pharmacies.view_historicalproductsprocessing',
  },

  PRESCRIPTIONSPROCESSING: {
    VIEW: 'pharmacies.view_prescriptionsprocessing',
    ADD: 'pharmacies.add_prescriptionsprocessing',
    EDIT: 'pharmacies.change_prescriptionsprocessing',
    VIEW_HISTORY: 'pharmacies.view_historicalprescriptionsprocessing',
  },

  VOUCHERPROCESSING: {
    VIEW: 'biochemists.view_voucherprocessing',
    ADD: 'biochemists.add_voucherprocessing',
    EDIT: 'biochemists.change_voucherprocessing',
    VIEW_HISTORY: 'biochemists.view_historicalvoucherprocessing',
  },

  VOUCHERDETAILSPROCESSING: {
    VIEW: 'biochemists.view_voucherdetailprocessing',
    ADD: 'biochemists.add_voucherdetailprocessing',
    EDIT: 'biochemists.change_voucherdetailprocessing',
    VIEW_HISTORY: 'biochemists.view_historicalvoucherdetailprocessing',
  },

  FILEPAYMENT: {
    VIEW: 'files.view_filepayment',
    ADD: 'files.add_filepayment',
    EDIT: 'files.change_filepayment',
    VIEW_HISTORY: 'files.view_historicalfilepayment',
  },

  VOLUNTARY_PAYMENTS: {
    VIEW: 'voluntary_payments.view_voluntarypayment',
    ADD: 'voluntary_payments.add_voluntarypayment',
    EDIT: 'voluntary_payments.change_voluntarypayment',
  },

  LIQUIDATIONS: {
    VIEW: 'payments.view_fileliquidation',
    ADD: 'payments.add_fileliquidation',
    EDIT: 'payments.change_fileliquidation',
    VIEW_HISTORY: 'payments.view_historicalfileliquidation',
    VIEW_TRANSACTIONS: 'payments.view_fileliquidationtransaction',
    ADD_TRANSACTION: 'payments.add_fileliquidationtransaction',
  },

  LIQUIDATIONS_THIRDPARTY: {
    VIEW: 'payments.view_fileliquidationthirdparty',
    ADD: 'payments.add_fileliquidationthirdparty',
    EDIT: 'payments.change_fileliquidationthirdparty',
    DELETE: 'payments.delete_fileliquidationthirdparty',
    VIEW_HISTORY: 'payments.view_historicalfileliquidationthirdparty',
    VIEW_TRANSACTIONS: 'payments.view_fileliquidationthirdpartytransaction',
    ADD_TRANSACTION: 'payments.add_fileliquidationthirdpartytransaction',
  },

  CHECK: {
    VIEW: 'payments.view_check',
    ADD: 'payments.add_check',
    EDIT: 'payments.change_check',
    VIEW_HISTORY: 'payments.view_historicalcheck',
  },

  ACCOUNTS: {
    VIEW_ALL: 'payments.view_all_accounts',
    VIEW: 'payments.view_account',
    ADD: 'payments.add_account',
    EDIT: 'payments.change_account',
    VIEW_HISTORY: 'payments.view_historicalaccount',
  },

  ACCOUNTS_DEPOSIT: {
    VIEW: 'payments.view_deposit',
    ADD: 'payments.add_deposit',
    EDIT: 'payments.change_deposit',
  },

  ACCOUNTS_WITHDRAW: {
    VIEW: 'payments.view_withdrawal',
    ADD: 'payments.add_withdrawal',
    EDIT: 'payments.change_withdrawal',
  },

  ACCOUNTS_TRANSFER: {
    VIEW: 'payments.view_transfer',
    ADD: 'payments.add_transfer',
    EDIT: 'payments.change_transfer',
  },

  ACCOUNTS_PAYMENT: {
    VIEW: 'payments.view_payment',
    ADD: 'payments.add_payment',
    EDIT: 'payments.change_payment',
  },

  ACCOUNTS_COLLECTIONS: {
    VIEW: 'payments.view_collection',
    ADD: 'payments.add_collection',
    EDIT: 'payments.change_collection',
  },

  DISEASE_DIAGNOSE: {
    VIEW: 'diagnoses.view_diseasediagnose',
    ADD: 'diagnoses.add_diseasediagnose',
    EDIT: 'diagnoses.change_diseasediagnose',
  },

  DISABILITY_DIAGNOSE: {
    VIEW: 'diagnoses.view_disabilitydiagnose',
    ADD: 'diagnoses.add_disabilitydiagnose',
    EDIT: 'diagnoses.change_disabilitydiagnose',
    VIEW_CURRENT: 'diagnoses.view_current_disabilities',
  },

  PEOPLE: {
    VIEW: 'people.view_person',
    EDIT: 'people.change_person',
  },
};
